export default __webpack_public_path__ + "media/manifesto-office-lomas.798b1e22.jpg";